import MenuContentAddContainer from 'components/feature/menu/add/MenuContentAddContainer';

const MenuContentsAddPage = () => {
  return <MenuContentAddContainer />;
};
export default MenuContentsAddPage;
